module.exports = __webpack_public_path__ + "img/map-6.4364065b.svg";